module.exports = __webpack_public_path__ + "static/media/banesco-icon.2027ea76.svg";